import React from 'react';
import Modal from '../../shared/Modal';
import Slider from 'react-slick';
import style from '../../../../packs/slick_carousel_style';
import { OrganizationCard } from '../cards/OrganizationCard';
import { DiscoverOpportunities } from '../DiscoverOpportunities';

// PARTNERSHIP OPPORTUNITIES
const DiscoverTab = ({
	headers,
	recently_added,
	organizationData,
	setOrganizationData,
	modalContentOrganizations,
}) => {
	return (
		<div id="discover">
			<div className="new-organizations-container">
				<DiscoverOpportunities
					mask_content={false}
					organizationData={organizationData}
					header={headers.opportunities}
				/>

				<div className="row">
					<div className="columns small-12">
						<h2>{headers.recently_added.fields['en-US'].title}</h2>
						<p>{headers.recently_added.fields['en-US'].subtitle}</p>
					</div>
				</div>
				<div className="row">
					<div className="columns small-12 carousel-container">
						<Slider {...style}>
							{recently_added.map((orgData, index) => {
								return (
									<OrganizationCard
										orgData={orgData}
										key={index}
										heartButtonFunction={() =>
											setOrganizationData(orgData)
										}
										params="?kind=recently_added"
									/>
								);
							})}
						</Slider>
					</div>
				</div>
				{console.log(headers)}
				<DiscoverOpportunities
					mask_content={false}
					organizationData={organizationData}
					header={headers.social_opportunities}
					isSocial={true}
				/>
			</div>
			<Modal
				Content={modalContentOrganizations}
				modalState={organizationData}
				turnOffModal={() => setOrganizationData('')}
				style={{ width: '15rem', padding: '1rem' }}
			/>
		</div>
	);
};

export default DiscoverTab;
